import styled from 'styled-components';

export const SCAutoCompleteWrapper = styled.div`
    width: 100%;
    input {
        width: 100% !important;
    }
`;
